import { gql } from '@apollo/client';

export const ASSESSMENT_FIELDS = gql`
  fragment AssessmentFields on Assessment {
    approverId
    assessmentDate
    assessmentId
    assessmentStatus
    completedTasks
    improvementOpportunities
    incompleteTasks
    rating
    referenceId
  }
`;
